import React from 'react'

import Icon from '../../kiti/components/shapes/Icon'

const EditorIcon = ({ icon, active, onClick, ...props }) => {
  const handleMouseDown = e => {
    e.preventDefault()
    onClick()
  }

  return (
    <a style={{ display: 'flex' }} onMouseDown={onClick && handleMouseDown}>
      <Icon size={0.9} name={icon} color={active ? 'dark1' : 'light5'} {...props} />
    </a>
  )
}

export default EditorIcon
